var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("h1", { staticClass: "title", class: { isPc: !_vm.isSp } }, [
    _vm._v(_vm._s(_vm.titleText)),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }